// extracted by mini-css-extract-plugin
export default {"link":"pN-z","disabled":"qN-z"};